

exports.__esModule = true;
exports.$apiErrorHandler = $apiErrorHandler;
exports.$exceptionHandler = $exceptionHandler;
exports.$forbiddenHandler = $forbiddenHandler;
var _angular = require("angular");
var _uiRouter = require("uiRouter");
var _squid = require("squid");
var _index = require("xo-models/src/auth/index");
var _logger = require("xo-beaver/dist/logger");
var _fallback = require("./fallback");
var _contingency = require("./contingency");
var ERROR_STATE;
var ERROR_PREVENTED;
function $apiErrorHandler(err) {
  if (err instanceof _squid.$ApiError) {
    _logger.$logger.error('api_error', {
      error: err.toString()
    });
    throw new _squid.$FallbackError({
      reason: 'api_error',
      product: 'ux'
    });

    // @TODO - wtf?
    return true; // eslint-disable-line no-unreachable
  }
}
function $forbiddenHandler(err) {
  if (err instanceof _squid.$Forbidden) {
    _logger.$logger.warn('forbidden_handler');
    _index.$AuthModel.instance().invalidate();
    throw new _squid.$FallbackError({
      reason: 'user_not_logged_in',
      product: 'ux'
    });
  }
}
var handlers = [{
  type: _squid.$FallbackError,
  handle: _fallback.$fallbackErrorHandler
}, {
  type: _squid.$Contingency,
  handle: _contingency.$contingencyHandler
}, {
  type: _squid.$Forbidden,
  handle: $forbiddenHandler
}];
function $exceptionHandler(err, cause) {
  if (ERROR_STATE) {
    if (ERROR_PREVENTED) {
      throw err;
    }
    return;
  }

  // non token based Guest Upgrade Flow
  if (_squid.$util.param('data')) {
    _logger.$logger.error('guest_upgrade_error', {
      error: err
    });
    _uiRouter.$state.go('guestupgrade.genericError', {
      code: 'GUEST_UPGRADE_ERROR'
    });
    return;
  }
  var handled = handlers.some(function (handler) {
    if (err instanceof handler.type) {
      handler.handle(err);
      return true;
    }
    return false;
  });
  if (handled) {
    return;
  } else if (!err["transient"]) {
    ERROR_STATE = err;
  }
  var errType = (err.constructor.name || 'error').toLowerCase();
  var errName = "ui_unhandled_" + errType;
  var errMsg = err.message || '';
  if (errMsg.indexOf('infdig') > -1) {
    errName = 'infinite_digest';
  } else if (errMsg.indexOf('inprog') > -1) {
    errName = 'digest_inprog';
  } else if (errMsg.indexOf('badparse') > -1) {
    errName = 'sanitize_badparse';
  } else if (errMsg.match(/^[\w_]+$/) && !(err instanceof _squid.$Error)) {
    errName = errMsg;
  }
  if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
    if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
      errName = 'ui_unhandled_framework_error';
    }
  }
  var errObj = {
    error: err.stack || err.toString(),
    message: errMsg,
    cause: cause && cause.toString(),
    state: _uiRouter.$state.current.name,
    url: _angular.$window.location.toString()
  };
  _logger.$logger.error(errName, errObj);

  // emit the error object for subscribers like xo-tracking
  var event = _angular.$rootScope.$emit('unhandled_error', {
    route: (_uiRouter.$state || {}).current,
    message: errObj.error,
    code: errObj.cause,
    currentRoute: _uiRouter.$state.current
  });
  if (event.defaultPrevented) {
    ERROR_PREVENTED = true;
    throw err;
  } else if (!err["transient"]) {
    return (0, _fallback.$fallbackErrorHandler)(new _squid.$FallbackError({
      reason: errName
    }));
  }
}
function constructEventName(toState, fromState) {
  var fromStateFormatted = fromState.name.replace(/\./g, '_') || 'start';
  var toStateFormatted = toState.name.replace(/\./g, '_') || 'end';
  return "state_change_" + fromStateFormatted + "_to_" + toStateFormatted;
}
var stateChangeError = _angular.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
  // Set prevent default to avoid angular UI router to keep looping back to same state
  event.preventDefault();
  $exceptionHandler(err, constructEventName(toState, fromState));
});
var windowError = _angular.$rootScope.$on('$windowError', function (event, details) {
  _logger.$logger.error('window_error', details, {
    debounceFactor: details.message,
    debounceInterval: 1000
  });
});
_angular.$rootScope.$on('$destroy', stateChangeError);
_angular.$rootScope.$on('$destroy', windowError);
angular.value("$apiErrorHandler", $apiErrorHandler);
angular.value("$forbiddenHandler", $forbiddenHandler);
angular.value("$exceptionHandlerLazy", $exceptionHandler);
_angular.$rootScope;
_angular.$window;
_uiRouter.$state;
_squid.$Forbidden;
_squid.$ApiError;
_squid.$FallbackError;
_squid.$util;
_squid.$Error;
_squid.$Contingency;
_index.$AuthModel;
_logger.$logger;
_fallback.$fallbackErrorHandler;
_contingency.$contingencyHandler;


//////////////////
// WEBPACK FOOTER
// ./js/lib/error.js
// module id = ./js/lib/error.js
// module chunks = 0